<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.LoginPage {
    .btn {
        width: 100%;
    }

    .control-label {
        display: none;
    }

    input.form-control {
        height: 58px;
        line-height: 58px;
        padding: 0 10px;
    }

    .password-field-wrapper {
        position: relative;

        input.form-control {
            padding-right: 45px;
        }

        .password-toggle-btn {
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: 45px;
            background: none;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999;
            font-size: 16px;
            outline: none;

            &:hover {
                color: #333;
            }
        }
    }

    .page-content {
        .m-b-none;
    }
}
</style>

<script type="text/babel">
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [RestoreOnPageBack],

    data() {
        return {
            open: false,
            showPassword: false,
            form: new SparkForm({
                email: '',
                password: '',
                remember: null,
            }),
        }
    },

    methods: {
        login() {
            Spark.post('/login', this.form).then(response => {
                Spark.redirect(response.redirect)
            })
        },
    },
}
</script>
